import { BlockItemMedia } from '@/models/Blocks/Itens/block-item-media';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';
import { BlockItemAction, BlockItemContent, BlockItemTimer } from '@/models/Blocks/Itens/Types/block-content-types';
//import prozisEventQueue from "../../../../../../../../src-js/monitor-user-behaviour-2/prozis-event-queue.js";


export class BlockContent extends BlockItemMedia {
    protected _title: BlockItemContent;
    protected _subtitle?: BlockItemContent;
    protected _action?: BlockItemAction;
    protected _timer?: BlockItemTimer;
    protected _icon?: string;
    protected _starRating?: number;
    protected _cssClass?: string;
    protected _isSeeMore?: boolean;
    protected _chatClickId?:string;

    public constructor(title: BlockItemContent, action: BlockItemAction|undefined) {
        super(BlockItemType.content);
        this._title = title;
        if(action){
            this._action = action;
            if(this._action.type === 'link'){
                this.url = this._action.value;
            }
        }
    }

    public get icon(): string|undefined {
        return this._icon;
    }

    public set icon(value: string|undefined) {
        this._icon = value;
    }

    public get cssClass(): string|undefined {
        return this._cssClass;
    }

    public set cssClass(value: string|undefined) {
        this._cssClass = value;
    }

    public get subtitle(): BlockItemContent|undefined {
        return this._subtitle;
    }

    public set subtitle(value: BlockItemContent|undefined) {
        this._subtitle = value;
    }

    public get title(): BlockItemContent{
        return this._title;
    }

    public set title(value: BlockItemContent) {
        this._title = value;
    }

    public get action(): BlockItemAction|undefined{
        return this._action;
    }

    public set action(value: BlockItemAction|undefined) {
        this._action = value;
    }

    public get timer(): BlockItemTimer|undefined{
        return this._timer;
    }

    public set timer(value: BlockItemTimer|undefined) {
        this._timer = value;
    }

    public get starRating(): number|undefined {
        return this._starRating;
    }

    public set starRating(value: number|undefined) {
        this._starRating = value;
    }

    public get isSeeMore(): boolean {
        return this._isSeeMore ? this._isSeeMore : false;
    }

    public set isSeeMore(value: boolean) {
        this._isSeeMore = value;
    }

    public set url(value: string|undefined){
        this._url = value;
    }

    public get url():string|undefined{
        let params: string = '';
        if(this._colorId){
            params += (params ? '&' : '') +  `clr=${this._colorId}`;
        }
        if(this.isSeeMore){
            params += (params ? '&' : '') +  `tp=sm`;
            if(this.extraInfo && (typeof this.extraInfo === 'object') && !Array.isArray(this.extraInfo)){
                Object.keys(this.extraInfo).forEach(key =>{
                    params += (params ? '&' : '') +  `${key}=${this.extraInfo[key]}`;
                });
            }
        }
        if(!params){
            return this._url;
        }
        return this._url + (this._url?.includes('?') ? '&' : '?') + params;
    }

    public get mubData():string|undefined{
        return !this.isSeeMore ? this._mub : JSON.stringify({
            t: 'viewMore',
            b: this.blockName,
            m: {}
        });
    }

    public set mubData(value: string|undefined){
        this._mub = value;
    }

    public get chatClickId():string|undefined{
        return this._chatClickId;
    }

    public set chatClickId(value: string|undefined){
        this._chatClickId = value;
    }

}